module.exports = "/_next/static/images/9cf6deadd56a7fe1c3a5a3f3f8eb2edf-document-avatar-4x.png.webp";